export const EnumDealValidationType = Object.freeze({
  None: 0,
  InternalValidation: 1,
  ClientValidation: 2,
  NewDeal: 3,
})
